<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="true"
            :pullDownLabel="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
        >
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
                    </div>
                    <div class="mobile_container" v-loading="loading">
                        <ul v-infinite-scroll="onLoadList">
                            <li
                                v-for="(row, rowIndex) in tableData"
                                :key="rowIndex"
                                class="list_item"
                                @click.stop="handleClickToDetail(row)"
                            >
                                <div class="list_item_left">
                                    <p class="ellipsis">{{ row.company_name }}</p>
                                    <p>已{{ row.overdue_days }}日未跟进</p>
                                </div>
                                <div class="list_item_right">
                                    <van-button size="small" plain type="info" @click.stop="handleClickAddFollowUp(row)"
                                        ><i class="iconfont icon-Edit"></i>写跟进</van-button
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
        </PullContainer>
        <AddCustomerFollowTpl
            v-if="addFollowTplPopupShow"
            :addFollowTplPopupShow.sync="addFollowTplPopupShow"
            :customer_id="Number(customer_id)"
            @addFollowTplSuccess="handleClickSearch"
        />
    </div>
</template>

<script>
import { OverdueFollowups } from "@/api";
import { pagination } from "@/mixins";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import AddCustomerFollowTpl from "./customer_follow_tpl.vue";
export default {
    name: "CustomerForgetReminder",
    components: {
        PullContainer,
        ReturnNavBar,
        AddCustomerFollowTpl,
    },
    data() {
        return {
            loading: false,
            tableData: [],
            // 写跟进
            customer_id: 0,
            addFollowTplPopupShow: false,
        };
    },
    mixins: [pagination],
    created() {
        this.getTableData();
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.handleClickSearch();
            }
        },
        handleClickSearch() {
            this.pagination.pageNum = 1;
            this.tableData = [];
            this.getTableData();
        },
        // 加载更多
        onLoadList() {
            if (this.pagination.total == this.tableData.length) {
                return false;
            }
            if (this.loading == false) {
                this.getTableData();
            }
        },
        getTableData() {
            this.loading = true;
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            };
            OverdueFollowups(postData).then((res) => {
                if (res.code === 200) {
                    let { list, total } = res.data;
                    this.tableData = this.tableData.concat(list);
                    this.pagination.total = total;
                    this.pagination.pageNum++;
                    this.loading = false;
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                }
            });
        },
        // 查看详情
        handleClickToDetail(row) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: row.customer_id,
                    name: row.company_name,
                },
            });
        },
        // 写跟进
        handleClickAddFollowUp(row) {
            this.customer_id = row.customer_id;
            this.addFollowTplPopupShow = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.mobile_container {
    padding: 10px 16px;
    ul {
        li {
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            padding: 10px;
            display: flex;
            margin-bottom: 10px;
            .list_item_left {
                flex: 1;
                p:nth-child(1) {
                    font-size: 16px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 24px;
                    color: rgba(41, 144, 240, 1);
                }
                P:nth-child(2) {
                    margin-top: 2px;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(153, 153, 153, 1);
                }
            }
            .list_item_right {
                width: 74px;
                flex-shrink: 0;
                .van-button {
                    margin-top: 12px;
                    width: 74px;
                    height: 24px;
                    line-height: 24px;
                    padding: 0;
                    border-color: rgba(34, 121, 214, 1);
                    border-radius: 4px;
                    color: rgba(34, 121, 214, 1);
                    font-size: 12px;
                    font-weight: 400;
                    .iconfont {
                        margin-right: 8px;
                        font-size: 14px;
                    }
                }
            }
            &:active {
                background-color: rgba(153, 153, 153, 0.04);
            }
        }
    }
}
</style>
